import { UserInfo } from '@/store/modules/user'
import Cookies from 'js-cookie'

// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus)

// User
const tokenKey = 'access_token'
const userKey = 'user_info'
const warehouse_id='warehouse_id'
const superAdminFlag='superAdminFlag'
export const getToken = () => Cookies.get(tokenKey)
export const setToken = (token: string) => Cookies.set(tokenKey, token)
export const removeToken = () => Cookies.remove(tokenKey)

export const getUserInfo = () => JSON.parse(Cookies.get(userKey) || '{}')
export const setUserInfo = (userInfo: UserInfo) => Cookies.set(userKey, userInfo)
export const removeUserInfo = () => Cookies.remove(userKey)

export const getWarehouseId = () => JSON.parse(Cookies.get(warehouse_id)||'[]')
export const setWarehouseId = (token:any) => Cookies.set(warehouse_id, JSON.stringify(token))
export const removeWarehouseId = () => Cookies.remove(warehouse_id)

export const getSuperAdminFlag = () => Cookies.get(superAdminFlag)
export const setSuperAdminFlag = (token: string) => Cookies.set(superAdminFlag, token)
export const removeSuperAdminFlag = () => Cookies.remove(superAdminFlag)